/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=b4d695ac&scoped=true"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"
import style0 from "./adv.vue?vue&type=style&index=0&id=b4d695ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d695ac",
  null
  
)

export default component.exports